/* Sticky announcement bar — height tracker
   Measures the announcement bar height and exposes it as
   --announcement-bar-height on :root, so a sticky header can
   stack below it without overlapping. */

(function () {
  function setHeight() {
    var bar = document.querySelector('.shopify-section.announcement-bar-section');
    var height = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setHeight);
  } else {
    setHeight();
  }

  window.addEventListener('resize', setHeight);
  window.addEventListener('load', setHeight);

  if (typeof ResizeObserver !== 'undefined') {
    var bar = document.querySelector('.shopify-section.announcement-bar-section');
    if (bar) {
      new ResizeObserver(setHeight).observe(bar);
    }
  }
})();
